<div class="container-fluid" style="margin-top: 1%;padding-top: 1%;">
  <div class="card">
    <div class="row m-1">
      <!-- <h1 class="tatkaal m-3 pt-1">Tatka<span style="color: #f8a920;">a</span>l</h1>
       <p class="align-middle mt-3 pt-2 pr-2">by</p>
       <h1 class="tatkaal mt-2 pt-1">DIGI<br>SPA<span style="color: #f8a920;">₹</span>SH</h1> -->
       <img src="../../../../../assets/images/Tatkaal by DigiSparsh.png" alt="">
    </div>    
  </div>
  
  <div class="cardbg mt-2">
    <div class="twocard">
      <div class="card">
        <div class="row">
          <div class="col-md-6">
            <input class="form-check-input ml-3 checkbox" type="radio" disabled readonly name="choice-radio" id="flexCheckChecked"
            (click)="checkInsured($event.target.checked)" [checked]="isInsured"/>
            <label class="form-check-label pl-3 pt-2" for="flexCheckChecked">
              <h2>Patient - Insured (Reimbursement / Cashless case)</h2>
            </label>
           
          </div>
          <div class="col-md-6">
            <input class="form-check-input ml-3 checkbox" type="radio" disabled readonly  name="choice-radio" id="flexCheckChecked"
            (click)="checkUninsured($event.target.checked)" [checked]="isUninsured"/>
            <label class="form-check-label pl-3 pt-2" for="flexCheckChecked">
              <h2> Patient - Uninsured </h2>
            </label>
            
          </div>
        </div>
      </div>
      <form [formGroup]="worldLineForm" style="width: 100%;" *ngIf="isInsured">
        
          <div style="padding: 30px;">
              <!-- <div class="row mb-1">
                  <div class="col-lg-4">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="flexCheckChecked" [checked]="checked"
                        (click)="checkrelation1($event.target.checked)" />
                      <label class="form-check-label" style="font-size: 17px !important;" for="flexCheckChecked">
                        Are Patient and  Payer the same?
                      </label>
                    </div>
                  </div>
                </div> -->
              <div class="row">
                
                <div class="col-md-4 mt-3">
                  <label class="control-label required">Patient Name</label>
                  <input type="text" class="form-control" placeholder="Enter Full Name" readonly
                   formControlName="patientName" [ngClass]="{
                    'is-invalid':
                      mobRequired.patientName.errors &&
                      (mobRequired.patientName.dirty ||
                        mobRequired.patientName.touched )
                  }">
                  <div *ngIf="
                  mobRequired.patientName.errors &&
                  (mobRequired.patientName.dirty ||
                    (mobRequired.patientName.touched && mobRequired.patientName.invalid) )
                " class="invalid-feedback">
                <small *ngIf="mobRequired.patientName.errors.required">Patient Name is required</small>
                <small *ngIf="mobRequired['patientName'].hasError('pattern')">Patient Name is not Valid</small>
              </div>
              </div>
                  <div class="col-md-4 mt-3">
                      <label class="control-label required">Payer Name</label> 
                      <input type="text" class="form-control" placeholder="Enter Full Name" readonly
                       formControlName="name" [ngClass]="{
                        'is-invalid':
                          mobRequired.name.errors &&
                          (mobRequired.name.dirty ||
                            mobRequired.name.touched )
                      }">
                      <div *ngIf="
                      mobRequired.name.errors &&
                      (mobRequired.name.dirty ||
                        (mobRequired.name.touched && mobRequired.name.invalid) )
                    " class="invalid-feedback">
                    <small *ngIf="mobRequired.name.errors.required">Payer Name is required</small>
                    <small *ngIf="mobRequired['name'].hasError('pattern')">Payer Name is not Valid</small>
                  </div>
                  </div>
                  <div class="col-md-4 mt-3">
                      <label class="control-label required">Payer's Email Id</label>
                      <input type="text" class="form-control" placeholder="Enter Email Id" readonly
                       formControlName="consumerEmailId" [ngClass]="{
                        'is-invalid':
                          mobRequired.consumerEmailId.errors &&
                          (mobRequired.consumerEmailId.dirty ||
                            mobRequired.consumerEmailId.touched )
                      }">
                      <div *ngIf="
                      mobRequired.consumerEmailId.errors &&
                      (mobRequired.consumerEmailId.dirty ||
                        (mobRequired.consumerEmailId.touched && mobRequired.consumerEmailId.invalid) )
                    " class="invalid-feedback">
                    <small *ngIf="mobRequired.consumerEmailId.errors.required">Email ID is required</small>
                    <small *ngIf="mobRequired['consumerEmailId'].hasError('pattern')">Email ID is not Valid</small>
                  </div>
                  </div>
                  <div class="col-md-4 mt-3">
                      <label class="control-label required">Payer's Mobile Number</label>
                      <input type="text" class="form-control" placeholder="Enter Mobile no" readonly
                       formControlName="consumerMobileNo" onKeyPress="if(this.value.length==10) return false;" [ngClass]="{
                        'is-invalid':
                          mobRequired.consumerMobileNo.errors &&
                          (mobRequired.consumerMobileNo.dirty ||
                            mobRequired.consumerMobileNo.touched )
                      }">
                      <div *ngIf="
                      mobRequired.consumerMobileNo.errors &&
                      (mobRequired.consumerMobileNo.dirty ||
                        mobRequired.consumerMobileNo.touched )
                    " class="invalid-feedback">
                    <small *ngIf="mobRequired.consumerMobileNo.errors.required">Mobile Number is
                      required</small>
                      <small *ngIf="mobRequired['consumerMobileNo'].hasError('pattern') "> Mobile number should be of 10 digits</small>
                  </div>
                  </div>
                  <div class="col-md-4 mt-3">
                      <label class="control-label required">Amount to be Blocked</label>
                      <input type="text" class="form-control" placeholder="Enter Amount" readonly
                       formControlName="totalamount" onKeyPress="if(this.value.length==10) return false;" [ngClass]="{
                        'is-invalid':
                          mobRequired.totalamount.errors &&
                          (mobRequired.totalamount.dirty ||
                            mobRequired.totalamount.touched )
                      }">
                       <div *ngIf="
                       mobRequired.totalamount.errors &&
                       (mobRequired.totalamount.dirty ||
                         mobRequired.totalamount.touched )
                     " class="invalid-feedback">
                     <small *ngIf="mobRequired.totalamount.errors.required">Block Amount Value is
                       required</small>
                       <small *ngIf="mobRequired['totalamount'].hasError('pattern') "> Block Amount should be digits only</small>
                   </div>
                  </div>
                  <div class="col-md-4 mt-3">
                      <label class="control-label required">Transaction Type</label>
                      <input type="text" class="form-control" placeholder="Transaction Type" readonly
                       formControlName="paymentMode" >
                      <!-- <select class="form-control" formControlName="paymentMode" id="" (change)="cardCheck($event.target.value)">
                        <option [disabled]="true" [selected]="true">Select Type</option>
                        <option value="UPI" [disabled]="true">Upi</option>
                        <option value="cards">Credit Card</option>
                      </select> -->
                      <h5 class="note mt-1" *ngIf="note">Only VISA and Master Card Allow</h5>
                  </div>
              </div>
          </div>
          <div class="row">
              <div class="col-md-6">
                  <button class="btn cancel-btn" mat-button (click)="proceedtopay()">Pay</button>
              </div>
              <div class="col-md-6">
                  
              </div>
          </div>
          
      </form>
      
      <form [formGroup]="worldLineForm" style="width: 100%;" *ngIf="isUninsured">
        
        <div style="padding: 30px;">
            <!-- <div class="row mb-1">
                <div class="col-lg-4">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="flexCheckChecked" [checked]="checked"
                      (click)="checkrelation1($event.target.checked)" />
                    <label class="form-check-label" style="font-size: 17px !important;" for="flexCheckChecked">
                      Are Patient and  Payer the same?
                    </label>
                  </div>
                </div>
              </div> -->
            <div class="row">
                
                <div class="col-md-4 mt-3" >
                    <label class="control-label required">Patient Name</label>
                    <input type="text" class="form-control" placeholder="Enter Full Name" readonly
                     formControlName="patientName" [ngClass]="{
                      'is-invalid':
                        mobRequired.patientName.errors &&
                        (mobRequired.patientName.dirty ||
                          mobRequired.patientName.touched )
                    }">
                    <div *ngIf="
                    mobRequired.patientName.errors &&
                    (mobRequired.patientName.dirty ||
                      (mobRequired.patientName.touched && mobRequired.patientName.invalid) )
                  " class="invalid-feedback">
                  <small *ngIf="mobRequired.patientName.errors.required">Guardian Name is required</small>
                  <small *ngIf="mobRequired['patientName'].hasError('pattern')">Guardian Name is not Valid</small>
                </div>
                </div>
                <div class="col-md-4 mt-3" *ngIf="!checked">
                  <label class="control-label required">Payer Name</label>
                  <input type="text" class="form-control" placeholder="Enter Full Name" readonly
                   formControlName="name" [ngClass]="{
                    'is-invalid':
                      mobRequired.name.errors &&
                      (mobRequired.name.dirty ||
                        mobRequired.name.touched )
                  }">
                  <div *ngIf="
                  mobRequired.name.errors &&
                  (mobRequired.name.dirty ||
                    (mobRequired.name.touched && mobRequired.name.invalid) )
                " class="invalid-feedback">
                <small *ngIf="mobRequired.name.errors.required">Payer Name is required</small>
                <small *ngIf="mobRequired['name'].hasError('pattern')">Payer Name is not Valid</small>
              </div>
              </div>
                <div class="col-md-4 mt-3">
                    <label class="control-label required">Payer's Email Id</label>
                    <input type="text" class="form-control" placeholder="Enter Email Id" readonly
                     formControlName="consumerEmailId" [ngClass]="{
                      'is-invalid':
                        mobRequired.consumerEmailId.errors &&
                        (mobRequired.consumerEmailId.dirty ||
                          mobRequired.consumerEmailId.touched )
                    }">
                    <div *ngIf="
                    mobRequired.consumerEmailId.errors &&
                    (mobRequired.consumerEmailId.dirty ||
                      (mobRequired.consumerEmailId.touched && mobRequired.consumerEmailId.invalid) )
                  " class="invalid-feedback">
                  <small *ngIf="mobRequired.consumerEmailId.errors.required">Email ID is required</small>
                  <small *ngIf="mobRequired['consumerEmailId'].hasError('pattern')">Email ID is not Valid</small>
                </div>
                </div>
                <div class="col-md-4 mt-3">
                    <label class="control-label required">Payer's Mobile Number</label>
                    <input type="text" class="form-control" placeholder="Enter Mobile no" readonly
                     formControlName="consumerMobileNo" onKeyPress="if(this.value.length==10) return false;" [ngClass]="{
                      'is-invalid':
                        mobRequired.consumerMobileNo.errors &&
                        (mobRequired.consumerMobileNo.dirty ||
                          mobRequired.consumerMobileNo.touched )
                    }">
                    <div *ngIf="
                    mobRequired.consumerMobileNo.errors &&
                    (mobRequired.consumerMobileNo.dirty ||
                      mobRequired.consumerMobileNo.touched )
                  " class="invalid-feedback">
                  <small *ngIf="mobRequired.consumerMobileNo.errors.required">Mobile Number is
                    required</small>
                    <small *ngIf="mobRequired['consumerMobileNo'].hasError('pattern') "> Mobile number should be of 10 digits</small>
                </div>
                </div>
                <div class="col-md-4 mt-3">
                    <label class="control-label required">Amount to Be Blocked</label>
                    <input type="text" class="form-control" placeholder="Enter Amount" readonly
                     formControlName="totalamount" onKeyPress="if(this.value.length==10) return false;" [ngClass]="{
                      'is-invalid':
                        mobRequired.totalamount.errors &&
                        (mobRequired.totalamount.dirty ||
                          mobRequired.totalamount.touched )
                    }">
                     <div *ngIf="
                     mobRequired.totalamount.errors &&
                     (mobRequired.totalamount.dirty ||
                       mobRequired.totalamount.touched )
                   " class="invalid-feedback">
                   <small *ngIf="mobRequired.totalamount.errors.required">Block Amount Value is
                     required</small>
                     <small *ngIf="mobRequired['totalamount'].hasError('pattern') "> Block Amount should be digits only</small>
                 </div>
                </div>
                <div class="col-md-4 mt-3">
                    <label class="control-label required">Transation Type</label>
                    <!-- <select class="form-control" formControlName="paymentMode" id="" (change)="cardCheck($event.target.value)">
                      <option [disabled]="true" [selected]="true">Select Type</option>
                      <option value="upi">Upi</option>
                      <option value="cards">Credit Card</option>
                    </select> -->
                    <input type="text" class="form-control" placeholder="Payment Type" readonly
                     formControlName="paymentMode"  >
                    <h5 class="note mt-1" *ngIf="note">Only VISA and Master Card Allow</h5>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
              <button class="btn cancel-btn" mat-button (click)="proceedtopay()">Pay</button>
            </div>
            <div class="col-md-6">
                
            </div>
        </div>
        
      </form>
    </div>
  </div>
</div>


   <!-- <button (click)="proceedtopay()">Proceed to Pay</button> -->
